import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useHistory } from 'react-router-dom';

import routes from 'routing/routes';
import account from 'ui/assets/img/dashboard-icons/illustrations-account.png';
import lead from 'ui/assets/img/dashboard-icons/group-5.png';
import support from 'ui/assets/img/dashboard-icons/group-2.png';
import { connect } from 'react-redux';
import { MODAL_OPEN } from 'redux/slices/modals';

import MainFont from '../../ui/typography/mainFont';
import {
  DashboardCard,
  DashboardCardContent,
  DashboardContainer,
  DashboardContent
} from './style';
import PropTypes from 'prop-types';
import {
  isAnAdmin,
  isCommercialRole,
  isPartnerAdmin
} from '../../utils/common';

const Dashboard = ({ role, openSupportModal }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [proPicHeight, setProPicHeight] = useState(0);
  const [countedElements, setCountedElements] = useState('');

  const checkRoles = () => {
    let count = 1;
    if (isCommercialRole(role) || isPartnerAdmin(role)) {
      count++;
    }
    if (isAnAdmin(role)) {
      count++;
    }
    // if (isTechnicalRole(role) || isPartnerAdmin(role)) {
    //   count++;
    // }
    // if (isCommercialRole(role) || isPartnerAdmin(role)) {
    //   count++;
    // }

    count === 4 ? setCountedElements(2) : setCountedElements(3);
  };

  useEffect(() => {
    checkRoles();
    const iconSectionHeight =
      parseInt(
        getComputedStyle(document.querySelector('#profile-pic-container'))
          ?.height,
        10
      ) +
      parseInt(
        getComputedStyle(document.querySelector('#profile-pic-container'))
          ?.marginBottom,
        10
      );
    parseInt(
      getComputedStyle(document.querySelector('#profile-pic-container'))
        ?.marginTop,
      10
    );
    setProPicHeight(iconSectionHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSupportModal = () => {
    openSupportModal();
  };

  return (
    <DashboardContainer proPicHeight={proPicHeight}>
      <DashboardContent countedElements={countedElements}>
        {(isCommercialRole(role) || isPartnerAdmin(role)) && (
          <DashboardCard
            onClick={() => {
              history.push(routes.lead.path);
            }}
          >
            <DashboardCardContent>
              <img src={lead} alt="lead icon" />
              <MainFont type="dashboardPartner">{t('lead')}</MainFont>
            </DashboardCardContent>
          </DashboardCard>
        )}
        {/* {(isCommercialRole(role) || isPartnerAdmin(role)) && (
          <DashboardCard>
            <DashboardCardContent>
              <img src={orders} alt="orders icon" />
              <MainFont type="dashboardPartner">{t('orders')}</MainFont>
            </DashboardCardContent>
          </DashboardCard>
        )} */}
        {isAnAdmin(role) && (
          <DashboardCard
            onClick={() => {
              history.push(routes.people.path);
            }}
          >
            <DashboardCardContent>
              <img src={account} alt="people icon" />
              <MainFont type="dashboardPartner">{t('people')}</MainFont>
            </DashboardCardContent>
          </DashboardCard>
        )}
        {/* {(isTechnicalRole(role) || isPartnerAdmin(role)) && (
          <DashboardCard>
            <DashboardCardContent>
              <img src={assignments} alt="assignments icon" />
              <MainFont type="dashboardPartner">{t('assignments')}</MainFont>
            </DashboardCardContent>
          </DashboardCard>
        )} */}
        <DashboardCard onClick={handleSupportModal}>
          <DashboardCardContent>
            <img src={support} alt="support icon" />
            <MainFont type="dashboardPartner">{t('support')}</MainFont>
          </DashboardCardContent>
        </DashboardCard>
      </DashboardContent>
    </DashboardContainer>
  );
};

Dashboard.propTypes = {
  role: PropTypes.string,
  openSupportModal: PropTypes.func,
  checkRoles: PropTypes.func
};

export default connect(
  ({ authentication }) => ({
    role: authentication.role
  }),
  dispatch => ({
    openSupportModal: payload =>
      dispatch(MODAL_OPEN({ id: 'support', payload }))
  })
)(Dashboard);
